import React, {useEffect, useState} from 'react';
import './TourBlock.scss';
import {Text} from "../index";
import {useDispatch, useSelector} from "react-redux";
import {Popover} from "antd";
import StepsList from "./components/StepsList/StepsList";
import {UpdateOpenStepsList} from "../../redux/actions/tourActions";
import {
    countSuccessSteps,
    getStepsLocal,
    KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6,
    STEPS
} from "./helpers";
import {GetChannels} from "../../redux/actions";
import {ROUTERS_MAP} from "../../utils/routes";
import {useLocation} from "react-router-dom";

const TourBlock = () => {
    const isFullWidth = useSelector(state => state.utils.isFullWidth);
    const isShowStepList = useSelector((state) => state.tour.isShowStepList);
    const dispatch = useDispatch();
    const locations = useLocation();
    const [isVisible, setIsVisible] = useState(false);
    const [count, setCount] = useState(0);
    const googleToken = useSelector(state => state.userCalendars?.googleToken);
    const outlookToken = useSelector(state => state.userCalendars.outlookInfo?.token?.access_token);
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const isConnectedCalendar = Boolean(googleToken) || Boolean(outlookToken);
    const [successSteps, setSuccessSteps] = useState({
        KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1: false,
        KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2: false,
        KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3: localStorage.getItem(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3),
        KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4: false,
        KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5: false,
        KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6: false,
    })

    useEffect(() => {
        dispatch(GetChannels());
    }, []);

    useEffect(() => {
        setCount(countSuccessSteps());
        setSuccessSteps(getStepsLocal());
    }, [isShowStepList]);

    useEffect(() => {
        setSuccessSteps({
            ...successSteps,
            KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1: isConnectedCalendar
        });
        !isConnectedCalendar ? localStorage.removeItem(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1) : localStorage.setItem(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1, isConnectedCalendar);
        setCount(countSuccessSteps())
    }, [googleToken, outlookToken]);


    useEffect(() => {
        setIsVisible(!Boolean(localStorage.getItem(KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK)));

        const handleLocalStorageChange = (e) => {
            const {key, value} = e.detail;

            if (key === KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK) {
                setIsVisible(!value);
            }

            const stepKeys = [
                KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2,
                KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3,
                KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4,
                KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5,
                KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6
            ];

            if (stepKeys.includes(key)) {
                setSuccessSteps(prev => ({
                    ...prev,
                    [key]: value
                }));
            }

            if (key === KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK || stepKeys.includes(key)) {
                setTimeout(() => {
                    setCount(countSuccessSteps());
                }, 300);
            }
        };

        window.addEventListener("localstorage-change", handleLocalStorageChange);
        return () => window.removeEventListener("localstorage-change", handleLocalStorageChange);
    }, []);

    function handleOpenChange(newOpen) {
        dispatch(UpdateOpenStepsList(newOpen))
    }

    if(locations?.pathname.includes(ROUTERS_MAP.AUTH) || locations?.pathname.includes(ROUTERS_MAP.CONNECT_CALENDAR) || locations?.pathname === '/'){
        return null;
    }

    return (
        <>
            {isVisible ?
                <div className="tour">
                    {isShowStepList ?
                        <Popover
                            arrow={false}
                            trigger='click'
                            placement="topLeft"
                            overlayClassName='popover_manage-chain'
                            destroyTooltipOnHide={true}
                            onOpenChange={activeStep === STEPS.SEVEN ? null : handleOpenChange}
                            open={activeStep === STEPS.SEVEN ? true : isShowStepList}
                            content={
                                <StepsList successSteps={successSteps} count={count}/>
                            }
                        >
                            <div className="tour__list" style={{left: isFullWidth ? 244 : 100}}>
                                f
                            </div>
                        </Popover>
                        :
                        <div
                            onClick={() => handleOpenChange(true)}
                            className="tour__mini" style={{left: isFullWidth ? 244 : 100}}
                        >
                            <Text size="f16" font="book" color="white">Get started ({count}/6)</Text>
                        </div>
                    }
                </div>
                : null}
        </>
    );
};

export default TourBlock;